import { useEffect, useState } from "@/utils/hooks/reactUseCustomHooks";
import { Box, Text } from "@dxp-feed/ui";
import React from "react";
import ImageWrapper from "../ImageWrapper";
import { TIME_ZONE, TIME_ZONE_LOCALE } from "@/utils/constant";

const OfferCardBadge = ({ promotions, className }: any) => {
  const [promotionsData, setPromotionsData] = useState<any>({});

  const getDaysDifferenceBetweenDatesEST = (
    startDateUnix: number,
    endDateUnix: number,
  ): number => {
    const startDate = new Date(startDateUnix * 1000);
    const endDate = new Date(endDateUnix * 1000);

    const startAtMidnight = new Date(startDate.toLocaleDateString(TIME_ZONE_LOCALE, { timeZone: TIME_ZONE }));
    const endAtMidnight = new Date(endDate.toLocaleDateString(TIME_ZONE_LOCALE, { timeZone: TIME_ZONE }));

    const diffMs = endAtMidnight.getTime() - startAtMidnight.getTime();
    const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));

    return diffDays;
  };


  useEffect(() => {
    if (promotions != undefined && promotions.length > 0) {
      const rewardDescription = promotions[0]?.rewardDescription;
      const rewardValue = promotions[0]?.rewardValue?.toString()?.includes(".")
        ? promotions[0]?.rewardValue?.toString()?.split(".")[0]
        : promotions[0]?.rewardValue;
      const rewardDecimalValue = promotions[0]?.rewardValue
        ?.toString()
        ?.includes(".")
        ? promotions[0]?.rewardValue?.toString()?.split(".")[1]
        : "";
      const rewardApplyTo = promotions[0]?.rewardApplyTo;
      const rewardTrigger = promotions[0]?.rewardTrigger;
      const offerIdentifier = promotions[0]?.offerIdentifier;
      const promotionDescription = promotions[0]?.promotionDescription;
      const numberOfDays = getDaysDifferenceBetweenDatesEST(
        promotions[0]?.promotionStartDate,
        promotions[0]?.promotionEndDate
      );
      const memberType = promotions?.[0]?.memberType ? promotions?.[0]?.memberType : "NNNNNNNNNNNNNNNN";
      const rewardType = promotions[0]?.rewardType;
      
      setPromotionsData({
        rewardDescription,
        rewardValue,
        rewardDecimalValue,
        rewardApplyTo,
        offerIdentifier,
        numberOfDays,
        rewardTrigger,
        memberType,
        rewardType
      });
    }
  }, [promotions]);
  const renderBadges = () => {
    if (promotionsData && promotionsData?.rewardType == 6 && promotionsData?.memberType?.includes("N")) {
      if ((promotionsData?.rewardTrigger == 1 || promotionsData?.rewardTrigger == '') && (promotionsData?.rewardApplyTo == 1 || promotionsData?.rewardApplyTo == ''))
        return (
          <Box as="div" className={`${className} absolute left-[10px] bottom-0`}>
            <ImageWrapper
              src={"/assets/badge_B1G1.png"}
              alt="B1G1"
              height={65}
              width={65}
            />
          </Box>
        );
      if (promotionsData?.rewardTrigger === 2 && promotionsData?.rewardApplyTo == 2)
        return (
          <Box as="div" className={`${className} absolute left-[10px] bottom-0`}>
            <ImageWrapper
              src={"/assets/badge_B2G2.png"}
              alt="B2G2"
              height={65}
              width={65}
            />
          </Box>
        );
      if (promotionsData?.rewardTrigger === 3 && promotionsData?.rewardApplyTo == 1)
        return (
          <Box as="div" className={`${className} absolute left-[10px] bottom-0`}>
            <ImageWrapper
              src={"/assets/badge_B2G3.png"}
              alt="B2G3"
              height={65}
              width={65}
            />
          </Box>
        );
      if (promotionsData?.rewardTrigger === 4 && promotionsData?.rewardApplyTo == 1)
        return (
          <Box as="div" className={`${className} absolute left-[10px] bottom-0`}>
            <ImageWrapper
              src={"/assets/badge_B3G4.png"}
              alt="B3G4"
              height={65}
              width={65}
            />
          </Box>
        );
      if (promotionsData?.rewardTrigger === 5 && promotionsData?.rewardApplyTo == 1)
        return (
          <Box as="div" className={`${className} absolute left-[10px] bottom-0`}>
            <ImageWrapper
              src={"/assets/badge_B4G5.png"}
              alt="B4G5"
              height={65}
              width={65}
            />
          </Box>
        );
      if (promotionsData?.rewardTrigger === 6 && promotionsData?.rewardApplyTo == 1)
        return (
          <Box as="div" className={`${className} absolute left-[10px] bottom-0`}>
            <ImageWrapper
              src={"/assets/badge_B5G6.png"}
              alt="B5G6"
              height={65}
              width={65}
            />
          </Box>
        );
      if (promotionsData?.rewardTrigger === 7 && promotionsData?.rewardApplyTo == 1)
        return (
          <Box as="div" className={`${className} absolute left-[10px] bottom-0`}>
            <ImageWrapper
              src={"/assets/badge_B6G7.png"}
              alt="B6G7"
              height={65}
              width={65}
            />
          </Box>
        );
    } else if (
      promotionsData &&
      promotionsData?.rewardType !== 1 &&
      promotionsData?.rewardType !== 2 &&
      promotionsData?.rewardType !== 3 &&
      promotionsData?.numberOfDays > 7 &&
     ( promotionsData?.offerIdentifier == "No Min Condition" || promotionsData?.offerIdentifier == "Multi promo only VKAO" || promotionsData?.offerIdentifier == "3 Promotions" || promotionsData?.offerIdentifier == "multi promo type 2" || promotionsData?.offerIdentifier == "multi promo type 1") &&
      promotionsData?.memberType?.includes('N')
    ) {
      return (
        <Box as="div" className={`${className} absolute left-[10px] bottom-0`}>
          <ImageWrapper
            src={"/assets/special-offer.png"}
            alt="Special Offer"
            height={65}
            width={65}
          />
        </Box>
      );
    } else if (
      promotionsData &&
      promotionsData?.rewardType !== 1 &&
      promotionsData?.rewardType !== 2 &&
      promotionsData?.rewardType !== 3 &&
      promotionsData?.numberOfDays <= 7 &&
      ( promotionsData?.offerIdentifier == "No Min Condition" || promotionsData?.offerIdentifier == "Multi promo only VKAO" || promotionsData?.offerIdentifier == "3 Promotions" || promotionsData?.offerIdentifier == "multi promo type 2" || promotionsData?.offerIdentifier == "multi promo type 1") &&
      promotionsData?.memberType?.includes('N')
    ) {
      return (
        <Box as="div" className={`${className} absolute left-[10px] bottom-0`}>
          <ImageWrapper
            src={"/assets/weekly-special.png"}
            alt="Weekly Special"
            height={65}
            width={65}
          />
        </Box>
      );
    } else if (
      promotionsData &&
      promotionsData?.rewardType == 2 &&
      promotionsData?.offerIdentifier?.includes("No Min Condition QTY 1") &&
      promotionsData?.memberType?.includes('N') &&
      promotionsData?.rewardTrigger == 2 && promotionsData?.rewardValue == 25
    ) {
      return (
        <Box as="div" className={`${className} absolute left-[10px] bottom-0`}>
          <ImageWrapper
            src={"/assets/badge_B1G2_25per.png"}
            alt="25% off"
            height={65}
            width={65}
          />
        </Box>
      );
    } else if (
      promotionsData &&
      promotionsData?.rewardType == 2 &&
      promotionsData?.offerIdentifier?.includes("No Min Condition QTY 1") &&
      promotionsData?.memberType?.includes('N') &&
      promotionsData?.rewardTrigger == 2 && promotionsData?.rewardValue == 50
    ) {
      return (
        <Box as="div" className={`${className} absolute left-[10px] bottom-0`}>
          <ImageWrapper
            src={"/assets/badge_B2G2_50per.png"}
            alt="50% off"
            height={65}
            width={65}
          />
        </Box>
      );
    }
  };

  return <>{renderBadges()}</>;
};

export default OfferCardBadge;
